import { useMemo } from 'react'

import { Select, SimpleGrid } from '@mantine/core'
import { useTranslate } from 'react-admin'
import { DateHelper } from '../helpers/Date.helper'

type LXDatePeriodProps = {
  month: string | undefined
  year: string | undefined
  monthLabel?: string
  yearLabel?: string
  disabledMonths?: string[]
  disabledYears?: string[]
  minYear?: number
  searchable?: boolean
  clearable?: boolean
  disabled?: boolean
  onUpdate: (month: string | undefined, year: string | undefined) => void
}

export const LXDatePeriod = ({
  month,
  year,
  monthLabel,
  yearLabel,
  disabledMonths = [],
  disabledYears = [],
  minYear,
  searchable = false,
  clearable = false,
  disabled = false,
  onUpdate,
}: LXDatePeriodProps) => {
  const t = useTranslate()

  const months = useMemo(
    () =>
      DateHelper.getMonths(t).map(m => {
        if (disabledMonths.includes(m.value)) {
          m.disabled = true
        }

        return m
      }),
    [t, disabledMonths],
  )
  const years = useMemo(
    () =>
      DateHelper.getYears().map(y => ({
        value: y.toString(),
        label: y.toString(),
        disabled: disabledYears.includes(y.toString()) || (minYear ? y < minYear : false),
      })),
    [disabledYears, minYear],
  )

  return (
    <SimpleGrid cols={2}>
      <Select
        label={monthLabel ?? t('_generics.month._title')}
        data={months}
        value={month}
        onChange={m => onUpdate(m ?? undefined, year)}
        searchable={searchable}
        clearable={clearable}
        disabled={disabled}
        autoComplete="off"
        data-form-type="other"
        maw={150}
        comboboxProps={{
          zIndex: 10000,
        }}
      />
      <Select
        label={yearLabel ?? t('_generics.year')}
        data={years}
        value={year}
        onChange={y => onUpdate(month, y ?? undefined)}
        searchable={searchable}
        clearable={clearable}
        disabled={disabled}
        autoComplete="off"
        data-form-type="other"
        maw={100}
        comboboxProps={{
          zIndex: 10000,
        }}
      />
    </SimpleGrid>
  )
}
